// extracted by mini-css-extract-plugin
module.exports = {"container":"DonateToYourselfModal_container__BnnKr","body":"DonateToYourselfModal_body__AjyYl"};